import { atom } from 'jotai'

export const imageBaseUrlState = atom<string>('');
